import API from "../axiosConfig";


export const getAllSettings = async () => {
  try {
    const response = await API.get("/settings");
    // Assuming the response is an array of {key: '...', value: '...'} objects
    // Convert it to an object like { key1: value1, key2: value2 }
    const settingsObject = response.data.reduce((acc, setting) => {
      acc[setting.key] = setting.value;
      return acc;
    }, {});
    return settingsObject;
  } catch (error) {
    console.error("Error fetching all settings:", error);
    throw error;
  }
};

export const updateSetting = async (key, value) => {
  try {
    const response = await API.put(`/settings/${key}`, { value });
    return response.data; // Contains { message: '...' }
  } catch (error) {
    console.error(`Error updating setting ${key}:`, error);
    throw error;
  }
};

